import { FormattedMessage } from 'react-intl'

import { Delete } from '@mui/icons-material'
import { LinearProgress, List, ListItem, ListItemIcon, Stack, Typography } from '@mui/material'

import { useTexts } from '../../useTexts'

type Props = {
  percentage: number
  totalOrders: number
  currentOrders: number
}

export function SimulationWarning(props: Props) {
  const { percentage, totalOrders, currentOrders } = props
  const texts = useTexts()

  return (
    <Stack width={444} direction="column" spacing={3}>
      <Stack direction="column" spacing={1}>
        <Stack direction="row" alignItems="center" spacing={2} width="100%">
          <LinearProgress
            variant="determinate"
            value={percentage}
            color="error"
            sx={{
              height: 8,
              flex: 1,
              borderRadius: '2px',
            }}
          />
          <Typography variant="body2">{`${percentage}%`}</Typography>
        </Stack>
        <Typography variant="caption">{`${currentOrders} of ${totalOrders} ${texts.ordersText}`}</Typography>
      </Stack>

      <Stack direction="column" spacing={2}>
        <Typography variant="body1">
          <FormattedMessage
            id="description"
            defaultMessage={texts.simulationDescription}
            values={{
              br: _ => <br />,
            }}
          />
        </Typography>

        <List
          sx={{
            gap: 2,
            padding: 0,
            '& > li': {
              mb: 2,
              gap: 2,
              padding: 0,
            },
          }}
        >
          <ListItem alignItems="flex-start">
            <ListItemIcon sx={{ minWidth: 'auto', m: 0 }}>
              <Delete />
            </ListItemIcon>

            <Typography variant="body1">
              <FormattedMessage
                id="option1"
                defaultMessage={texts.option1}
                values={{
                  b: chunks => (
                    <Typography component="span" variant="body1" display="inline" fontWeight="bold">
                      {chunks}
                    </Typography>
                  ),
                }}
              />
            </Typography>
          </ListItem>
        </List>
      </Stack>
    </Stack>
  )
}
